import React, { useEffect } from 'react';
import './mediclist.css';
import { IMedData, IMedicalCheck, statusMap } from '../../types/type';
import { fullName } from '../../utils/utils';
import { formatBackendDate, formatBackendTime } from '../../utils/date.utils';

function MedicList({
  sortedAndSearchedPosts,
  onUserClick,
}: {
  sortedAndSearchedPosts: Array<IMedicalCheck>;
  onUserClick: (id: string) => void;
}) {
  const data = sortedAndSearchedPosts as IMedicalCheck[];

  useEffect(() => {}, [sortedAndSearchedPosts]);

  return (
    <React.Fragment>
      {data.map((item) => (
        <React.Fragment key={item.id}>
          <tr className="table-row__medic">
            <td className={`medic__td __date`}>
              <span className="title__gray">Дата </span>
              {formatBackendDate(item.checkTime)}
            </td>
            <td className="medic__td">
              <div className="__patient">{fullName(item.driverProfile)}</div>
              <div>
                <span className="title__gray">Дата рождения</span> {formatBackendDate(item.driver?.birthDate)}
              </div>
            </td>
            <td className={`medic__td __info1`}>
              <div>
                <span className="title__gray">Темп.</span> {item.bodyTemperature}
              </div>
              <div>
                <span className="title__gray">Время.</span> {formatBackendTime(item.checkTime)}
              </div>
            </td>
            <td className={`medic__td __info2`}>
              <div>
                <span className="title__gray">Алкотестер</span> {item.bloodAlcohol}
              </div>
              <div>
                <span className="title__gray">Пульс</span> {item.heartRate}
              </div>
            </td>
            <td className={`medic__td __info3`}>
              <div>
                <span className="title__gray">Номер заявки</span> {item.num}
              </div>
              <div>
                <span className="title__gray">Давление</span> {item.bloodPressure}
              </div>
            </td>
            <td className="user-action">
              <div className="show__button">
                <div className="link-button" onClick={() => onUserClick(item.id)}>
                  Смотреть
                </div>
                <svg
                  className="icon__eye"
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.625 7.5C0.625 7.5 3.125 2.5 7.5 2.5C11.875 2.5 14.375 7.5 14.375 7.5C14.375 7.5 11.875 12.5 7.5 12.5C3.125 12.5 0.625 7.5 0.625 7.5Z"
                    stroke="#25282B"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M7.5 9.375C8.53553 9.375 9.375 8.53553 9.375 7.5C9.375 6.46447 8.53553 5.625 7.5 5.625C6.46447 5.625 5.625 6.46447 5.625 7.5C5.625 8.53553 6.46447 9.375 7.5 9.375Z"
                    stroke="#25282B"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <div
                className={
                  'status__button ' +
                  (item.status === 'completed' ? 'true' : item.status === 'rejected' ? 'false' : 'waiting')
                }
              >
                {statusMap[item.status as keyof typeof statusMap]}
              </div>
            </td>
          </tr>
          <tr key={`${item.id}-divider`} className="admin-table__item-divider" />
        </React.Fragment>
      ))}
    </React.Fragment>
  );
}

export default MedicList;
